export const en = {
    'clear-end-date-confirm-text':
        'The end date will be cleared. Ads will be served until the campaign runs out of funds.'
};
